import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function MediaCarousel(handle, {
    navigationHandle,
    prevHandle,
    nextHandle,
    sliderClass

}) {
    const sliderElement = handle.querySelector('.' + sliderClass);
    const navigation = handle.querySelector(navigationHandle);
    const prev = handle.querySelector(prevHandle);
    const next = handle.querySelector(nextHandle);

    const swiper = new Swiper(sliderElement, {
        modules: [Navigation],
        loop: true,
        navigation: {
            prevEl: prev,
            nextEl: next,
        },
        height: 600,
        spaceBetween: 0,
        breakpoints: {
            992: {
                slidesPerView: 3,
                centeredSlides: true,
                centerInsufficientSlides: true
            },
        },
    });
}
